module.exports = __webpack_public_path__ + "static/media/newcovinoc.cfee8c40.svg";